module.exports = "./images/logo-shopgate.png";